export default "__VITE_ASSET__BbnOX4Qy__"